"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DEFAULT_TRANSLATIONS = void 0;
var DEFAULT_TRANSLATIONS = {
  title: 'Terms & Conditions',
  validMessage: 'Valid until {0}'
};
exports.DEFAULT_TRANSLATIONS = DEFAULT_TRANSLATIONS;